import { MdArchive } from "react-icons/md";

import ConfirmButton from "./ConfirmButton";

const ArchiveButton: TTButtonProps = ({ children, as: component, ...props }) => {
  const Element = component || ConfirmButton;

  return (
    <Element {...props}>
      <MdArchive /> {children}
    </Element>
  );
};

export default ArchiveButton;
